import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import ShopikoSliderTemplatesData from './templates/shopiko/ShopikoSliderTemplatesData';
import ShopikoTemplatesModal from '@components/base/Modal/ShopikoTemplatesModal/ShopikoTemplatesModal';

const BG = {
	blockTitle: '20+ готови шаблона',
	blockDesc: 'Дизайни, които ще подпомогнат бързия старт на твоя онлайн магазин.',
	defaultCategory: ShopikoSliderTemplatesData,
	startHintAnimation: false,
	hintAnimationParams: {
		animateTo: 3,
		returnTo: 0
	},
	buttonText: 'Всички дизайни',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: ShopikoTemplatesModal,
	buttonModalParams: {}
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '20+ ready-made templates',
	blockDesc: 'Templates designed to help you launch and grow your online store quickly.',
	defaultCategory: ShopikoSliderTemplatesData,
	startHintAnimation: true,
	hintAnimationParams: {
		animateTo: 3,
		returnTo: 0
	},
	buttonText: 'See all designs',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: ShopikoTemplatesModal,
	buttonModalParams: {}
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];